import { ScrollableCurriculumTabStrip } from "@/components/ui/scrollable-curriculum-tab-strip";
import { Tabs, TabsContent, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";
import { BeltRank } from "../../MembersArea";

const DEFAULT_TAB_SURFACE = "!bg-gray-200 !text-gray-900";

interface SipJinProps {
  selectedBelt: BeltRank;
  getBeltColor: (belt: BeltRank) => string;
  hasDemo?: (aliases: string[]) => boolean;
  onWatchDemo?: (aliases: string[]) => void;
  presentation?: "legacy" | "curriculum";
  beltTabSurfaceClass?: string;
}

function SipJinMovesOl() {
  return (
    <ol className="list-none space-y-2">
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">Note:</span>
                      <span className="text-gray-700">The movements in this poomsae are based around Shí, the Chinese character for 10. This character is shaped like a + sign. Other than Hansoo/Hansu, this is the only form in WT to start in the middle.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">Ready:</span>
                      <span className="text-gray-700">Ready stance</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">1.</span>
                      <span className="text-gray-700">Without stepping, Bull Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">2a.</span>
                      <span className="text-gray-700">Without stepping, open the arms and pause briefly.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">2b.</span>
                      <span className="text-gray-700">The Left Arm of the + Sign</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">3.</span>
                      <span className="text-gray-700">Move the left foot into a Right Back Stance (i.e., left foot forward). Left Palm Augmented Outward Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">4a.</span>
                      <span className="text-gray-700">Slowly open the left fist. Twist the left wrist inward. Slide the left foot forward into Left Front Stance.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">4b.</span>
                      <span className="text-gray-700">Without stepping, Right Horizontal Fingertip Thrust (i.e., Horizontal Spearhand)</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">4c-d.</span>
                      <span className="text-gray-700">Without stepping, Left then Right Punch.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">5.</span>
                      <span className="text-gray-700">Step forward with the right foot to turn 90 right into Horse Stance, looking right. Opening Mountain Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">6a.</span>
                      <span className="text-gray-700">Step with the left foot to place it in front of the right foot into Cross Stance. Grab your opponent with the left hand and chamber the right hand for a Side Punch.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">6b.</span>
                      <span className="text-gray-700">Continue moving in the same direction; step with the right foot into a Horse Stance. Right Side Punch. Kihap.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">7.</span>
                      <span className="text-gray-700">Step with the right foot to turn 180 counterclockwise into Horse Stance. Double Elbow Strike.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">8.</span>
                      <span className="text-gray-700">The Right Arm of the + Sign</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">9.</span>
                      <span className="text-gray-700">Bring the left foot to the right foot, then step with the right foot into a Left Back Stance (i.e., right foot forward). Right Palm Augmented Outward Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">10a.</span>
                      <span className="text-gray-700">Slowly open the right fist. Twist the right wrist inward. Slide the right foot forward into Right Front Stance.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">10b.</span>
                      <span className="text-gray-700">Without stepping, Left Horizontal Fingertip Thrust (i.e., Horizontal Spearhand)</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">10c-d.</span>
                      <span className="text-gray-700">Without stepping, Right then Left Punch.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">11.</span>
                      <span className="text-gray-700">Step forward with the left foot to turn 90 left into Horse Stance, looking left. Opening Mountain Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">12a.</span>
                      <span className="text-gray-700">Step with the right foot to place it in front of the left foot into Cross Stance. Grab your opponent with the right hand and chamber the left hand for a Side Punch.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">12b.</span>
                      <span className="text-gray-700">Continue moving in the same direction; step with the left foot into a Horse Stance. Left Side Punch. Kihap.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">13.</span>
                      <span className="text-gray-700">Step with the left foot to turn 180 clockwise into Horse Stance. Double Elbow Strike.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">14.</span>
                      <span className="text-gray-700">Moving Down the + Sign</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">15.</span>
                      <span className="text-gray-700">Step backward with the right foot to turn 180 clockwise, into Left Back Stance (i.e., right foot forward). Right Palm Augmented Outward Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">16a.</span>
                      <span className="text-gray-700">Slowly open the right fist. When the fingers are nearly open, start twisting the right wrist inward. The left hand continues to support. Slide the right foot into Right Front Stance.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">16b.</span>
                      <span className="text-gray-700">Without stepping, complete the movement started in 16a by performing a Left Horizontal Fingertip Thrust.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">16c-d.</span>
                      <span className="text-gray-700">Without stepping, Left then Right Punch.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">17.</span>
                      <span className="text-gray-700">Step forward with the left foot into Right Back Stance (i.e., left foot forward). Double Knifehand Low Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">18a.</span>
                      <span className="text-gray-700">Step forward with the right foot into Right Front Stance. Bring the hands to the right side of the waist, palms open and thumbs pointing toward each other.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">18b.</span>
                      <span className="text-gray-700">Without stepping, Right Boulder Push.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">19.</span>
                      <span className="text-gray-700">Pivot 90 counterclockwise, slide the right foot back to Horse Stance. Ridgehand Opening Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">20.</span>
                      <span className="text-gray-700">Without stepping, Double Knifehand Low Opening Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">21.</span>
                      <span className="text-gray-700">Slowly close the fists so that you're in the position of a Low Opening Block. When the hands are almost closed, straighten the legs into a Wide Stance.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">22.</span>
                      <span className="text-gray-700">Pivot 90 counterclockwise into Left Front Stance. Pull Up Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">23a.</span>
                      <span className="text-gray-700">Without stepping, bring the hands to the right side of the waist, palms open and thumbs pointing toward each other.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">23b.</span>
                      <span className="text-gray-700">Without stepping, Right Boulder Push.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">24.</span>
                      <span className="text-gray-700">Moving Up the + Sign</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">25a.</span>
                      <span className="text-gray-700">Right Front Kick.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">25b.</span>
                      <span className="text-gray-700">Set the right foot down into Right Front Stance. Simultaneous Punch.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">26a.</span>
                      <span className="text-gray-700">Left Front Kick.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">26b.</span>
                      <span className="text-gray-700">Set the left foot down into Left Front Stance. Simultaneous Punch.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">27a.</span>
                      <span className="text-gray-700">Right Front Kick.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">27b.</span>
                      <span className="text-gray-700">Stomp the right foot down in front, moving the left foot back into a Cross Stance. Right Augmented High Backfist Strike. Kihap.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">28.</span>
                      <span className="text-gray-700">Again Moving Down the + Sign</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">29.</span>
                      <span className="text-gray-700">Step with the left foot to turn 180 counterclockwise into Left Front Stance. Right Boulder Push.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">30.</span>
                      <span className="text-gray-700">Slide the left foot back to Right Tiger Stance (i.e., left foot forward). Knifehand Low Cross Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">31.</span>
                      <span className="text-gray-700">Step forward with the right foot into Left Back Stance (i.e., right foot forward). Right Ridgehand Middle Block.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">32.</span>
                      <span className="text-gray-700">Step forward with the left foot into Right Back Stance (i.e., left foot forward). Simultaneous Punch.</span>
                    </li>
                    <li className="flex">
                      <span className="mr-2 text-taekwondo-red">33.</span>
                      <span className="text-gray-700">Step forward with the right foot into Left Back Stance (i.e., right foot forward). Simultaneous Punch.</span>
                    </li>
                <li className="flex">
                  <span className="mr-2 text-taekwondo-red">End:</span>
                  <span className="text-gray-700">Step with the right foot to turn 180 to the ready position; end.</span>
                </li>
              </ol>

  );
}

export default function SipJin({
  selectedBelt,
  getBeltColor: _getBeltColor,
  hasDemo,
  onWatchDemo,
  presentation = "legacy",
  beltTabSurfaceClass = DEFAULT_TAB_SURFACE,
}: SipJinProps) {
  if (!["BLACK/D4", "BLACK/D5"].includes(selectedBelt)) {
    return null;
  }

  const surface = beltTabSurfaceClass;
  const triggerClass = cn(
    "inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-black/10 px-3 py-2 text-xs font-medium md:text-sm",
    surface,
    "data-[state=active]:z-10 data-[state=active]:shadow-md data-[state=active]:ring-2 data-[state=active]:ring-gray-900/40 data-[state=active]:ring-offset-2 data-[state=active]:ring-offset-gray-100",
  );

  const demoBtn =
    hasDemo?.(["sip_jin", "sipjin"]) ? (
      <button
        type="button"
        className="inline-flex items-center text-sm font-medium text-taekwondo-blue hover:underline"
        onClick={() => onWatchDemo?.(["sip_jin", "sipjin"])}
      >
        Watch Demonstration Video
      </button>
    ) : null;

  if (presentation === "curriculum") {
    return (
      <div className="rounded-lg bg-gray-50 p-4 md:p-5">
        <h2 className="mb-2 text-lg font-semibold text-taekwondo-red md:text-xl">SipJin</h2>
        {demoBtn && <div className="mb-3">{demoBtn}</div>}
        <Tabs defaultValue="pattern-information" className="w-full space-y-4">
          <ScrollableCurriculumTabStrip ariaLabelPrefix="SipJin">
            <TabsTrigger value="pattern-information" className={triggerClass}>
              Pattern Information
            </TabsTrigger>
            <TabsTrigger value="details" className={triggerClass}>
              Details
            </TabsTrigger>
            <TabsTrigger value="meaning" className={triggerClass}>
              Meaning
            </TabsTrigger>
            <TabsTrigger value="key-techniques" className={triggerClass}>
              Key Techniques
            </TabsTrigger>
            <TabsTrigger value="pattern" className={triggerClass}>
              Pattern
            </TabsTrigger>
          </ScrollableCurriculumTabStrip>

          <TabsContent value="pattern-information" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Pattern Information</h4>
              <p className="mb-4 text-gray-700">
                SipJin represents the decimal system and its philosophical implications in martial arts. The pattern emphasizes the interconnection of
                numbers and their relationship to martial techniques, demonstrating how basic elements combine to create complex movements.
              </p>
            </div>
          </TabsContent>
          <TabsContent value="details" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Pattern Details</h4>
              <ul className="list-disc space-y-1 pl-5 text-gray-700">
                <li>Number of Movements: 28</li>
                <li>Pattern Diagram: Plus / decimal (十) — movements follow the &quot;ten&quot; shape</li>
                <li>Starting Position: Center of the diagram (Ready stance); unlike most WT forms, performance begins at the middle of the line</li>
              </ul>
            </div>
          </TabsContent>
          <TabsContent value="meaning" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Meaning</h4>
              <p className="text-gray-700">
                SipJin means &quot;Decimal&quot; or &quot;Ten Progress,&quot; symbolizing how fundamental elements combine in systematic ways to create advanced
                techniques. The pattern demonstrates the progression from basic to complex movements through mathematical precision and systematic
                combination.
              </p>
            </div>
          </TabsContent>
          <TabsContent value="key-techniques" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Key Techniques</h4>
              <ul className="list-disc space-y-1 pl-5 text-gray-700">
                <li>Systematic combinations</li>
                <li>Precise angular movements</li>
                <li>Mathematical patterns</li>
                <li>Progressive complexity</li>
                <li>Geometric formations</li>
                <li>Sequential techniques</li>
              </ul>
            </div>
          </TabsContent>
          <TabsContent value="pattern" className="mt-0 focus-visible:outline-none">
            <div>
              <h4 className="mb-2 text-base font-medium text-taekwondo-red">Movements</h4>
              <SipJinMovesOl />
            </div>
          </TabsContent>
        </Tabs>
      </div>
    );
  }

  return (
    <div className="mt-2 rounded-lg bg-gray-50 p-4">
      <div className="space-y-4">
        <div>
          {hasDemo?.(["sip_jin", "sipjin"]) && (
            <button
              type="button"
              className="mb-3 inline-flex items-center text-sm font-medium text-taekwondo-blue hover:underline"
              onClick={() => onWatchDemo?.(["sip_jin", "sipjin"])}
            >
              Watch Demonstration Video
            </button>
          )}
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Pattern Information</h4>
          <p className="mb-4 text-gray-700">
            SipJin represents the decimal system and its philosophical implications in martial arts. The pattern emphasizes the interconnection of
            numbers and their relationship to martial techniques, demonstrating how basic elements combine to create complex movements.
          </p>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Meaning</h4>
          <p className="text-gray-700">
            SipJin means &quot;Decimal&quot; or &quot;Ten Progress,&quot; symbolizing how fundamental elements combine in systematic ways to create advanced
            techniques. The pattern demonstrates the progression from basic to complex movements through mathematical precision and systematic
            combination.
          </p>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Key Techniques</h4>
          <ul className="list-inside list-disc space-y-1 text-gray-700">
            <li>Systematic combinations</li>
            <li>Precise angular movements</li>
            <li>Mathematical patterns</li>
            <li>Progressive complexity</li>
            <li>Geometric formations</li>
            <li>Sequential techniques</li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Training Focus</h4>
          <ul className="list-inside list-disc space-y-1 text-gray-700">
            <li>Pattern recognition</li>
            <li>Systematic progression</li>
            <li>Technical precision</li>
            <li>Combinatorial mastery</li>
            <li>Geometric awareness</li>
            <li>Mathematical timing</li>
          </ul>
        </div>

        <div>
          <h4 className="mb-3 text-base font-medium text-taekwondo-red">Movements</h4>
          <SipJinMovesOl />
        </div>
      </div>
    </div>
  );
}
